import React from "react";
import { useMediaQuery } from "react-responsive";
import { useGlobalContext } from "../../utils/globalContext";
import { trackCustom } from "../../services/analytics";
import TextSliderVertical from "./textSliderVertical";
import { Remarkable } from "remarkable";
import { Button } from "@speedoc/design-assets";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import useSlug from "../../hooks/useSlug";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ContactFormChronicV2 from "./contactFormChronicV2";
import SolutionsList from "./solutionsList";

const markdown = new Remarkable();

const Hero = ({ content }) => {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const downloadLink = useAppDownloadLink();
  const page = useSlug();
  const handleButtonClick = code => {
    trackCustom("Contact", code);
  };
  const { Trans } = useGlobalContext();

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const scrollToNextSection = () => {
    if (content.data?.anchorLink) {
      let div;
      try {
        div = document.querySelector(content.data?.anchorLink);
        const topPoint = div.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ behavior: "smooth", left: 0, top: topPoint });
      } catch {
        return;
      }
    }
  };

  const getHeroButtons = slug => {
    switch (slug) {
      case "mastercard":
        return (
          <>
            <a
              href={content.data?.whatsAppNumberLink ?? ""}
              className={`linkPrimary sm ${content.data?.isButtonNumbered ? "numbered" : ""}`}
              onClick={e => handleButtonClick(countryCode)}>
              <span>{content.data.mainButton}</span>
            </a>
            <a href={`/${countryCode.toLowerCase()}/`}>See all our solutions &#8594;</a>
          </>
        );
      default:
        if (!content.data?.mainButton) return null;
        else if (content.data?.anchorLink) {
          return (
            <Button onClick={scrollToNextSection} className={"linkPrimary sm"}>
              <span>{content.data.mainButton}</span>
            </Button>
          );
        } else {
          return (
            <a
              href={content.data?.whatsAppNumberLink || content.data?.buttonLink || downloadLink}
              className={`linkPrimary sm ${content.data?.isButtonNumbered ? "numbered" : ""}`}
              onClick={e => handleButtonClick(countryCode)}>
              <span>{content.data?.mainButton}</span>
            </a>
          );
        }
    }
  };

  return (
    <div id="hero">
      <div className="heroLeft">
        <div className="heroTexts">
          <h1 className="title">
            <span>
              <Trans>{content.title}</Trans>
            </span>
            {content.data?.dynamicContent && content.data?.dynamicContent.length ? (
              <div className="dynamic">
                <span className="static">Book </span>
                <TextSliderVertical content={content.data?.dynamicContent} />{" "}
              </div>
            ) : null}
          </h1>

          <div className="description">
            <div className="textBody" dangerouslySetInnerHTML={{ __html: markdown.render(content.description) }} />
          </div>
        </div>
        {isMobile && (
          <>
            {content.packageSelection?.images?.length && (
              <div className="img-logo">
                {content.packageSelection.images.map((image, i) => (
                  <img key={i} alt="logo" src={image.formats?.small.url || image.url} width={150} />
                ))}
              </div>
            )}
          </>
        )}
        {content.contactForm && content.contactForm.published && <ContactFormChronicV2 content={content.contactForm} />}
        {isMobile && (
          <>{content.packageSelection?.items?.length && <SolutionsList list={content.packageSelection?.items} />}</>
        )}
        <div className="ctaBox">{getHeroButtons(page)}</div>
      </div>
      <div className="heroRight">
        <LazyLoadImage src={content.image?.desktop?.url} alt="introduction" effect="blur" />
        {!isMobile && (
          <>
            {content.packageSelection?.images?.length && (
              <div className="img-logo">
                {content.packageSelection?.images.map((image, i) => (
                  <img key={i} alt="logo" src={image.formats?.small.url || image.url} width={150} />
                ))}
              </div>
            )}
            {content.packageSelection?.items?.length && <SolutionsList list={content.packageSelection?.items} />}
          </>
        )}
      </div>
    </div>
  );
};

export default Hero;
